"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledRemovableDiv = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var NestedIcon_1 = __importDefault(require("../../../Icon/NestedIcon"));
var RemovableDropdown_1 = __importDefault(require("../../inputs/RemovableDropdown"));
exports.StyledRemovableDiv = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var readOnly = _a.readOnly;
    return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ",
        "\n  "])), readOnly &&
        "div {\n        margin-right: 0 !important;\n      }");
});
var JazykySpecializace = function (_a) {
    var jazykySpecializace = _a.jazykySpecializace, onChange = _a.onChange, onRemove = _a.onRemove, options = _a.options, readOnly = _a.readOnly;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(exports.StyledRemovableDiv, { key: "jazyk-" + jazykySpecializace.id, readOnly: readOnly },
            react_1.default.createElement(RemovableDropdown_1.default, { leftIcon: react_1.default.createElement(NestedIcon_1.default, { active: true }), name: "jazyk-" + jazykySpecializace.id, placeholder: "Vyberte specializaci", value: jazykySpecializace.id, onChange: onChange, onRemove: onRemove, loadOptions: options, showAdd: !readOnly, disabled: readOnly, showRemove: !readOnly, readOnly: readOnly }))));
};
JazykySpecializace.defaultProps = {
    readOnly: undefined,
};
exports.default = JazykySpecializace;
var templateObject_1, templateObject_2;
